import Fetch from 'jsx/common/util/_fetch';
import { CustomField } from '@mss/mss-component-library';

export const Api = {
  toggle: async (customField: CustomField) => {
    return Fetch.put(`/api/custom-field/${customField.id}/`, {
      body: JSON.stringify(customField),
    });
  },
  post: async (customField: CustomField) => {
    return Fetch.post(`/api/custom-field/`, {
      body: JSON.stringify(customField),
    });
  },
  put: async (customField: CustomField) => {
    return Fetch.put(`/api/custom-field/${customField.id}/`, {
      body: JSON.stringify(customField),
    });
  },
  delete: async (customFieldId: string) => {
    if (customFieldId) {
      return Fetch.delete(`/api/custom-field/${customFieldId}/`, {});
    }
    return { status: 500 };
  },
  get: async (customFieldId: string) => {
    return Fetch.get(`/api/custom-field/${customFieldId}/`);
  },

  fetchEventLogStates: async (automationId: string) => {
    const result = await Fetch.get(`/api/automation/${automationId}/log/`);
    const data = await result.json();
    if (result.status >= 400) throw Error(result.statusText);

    return data;
  },

  fetchEventsByDate: async (automationId: string, date: string) => {
    const result = await Fetch.get(
      `/api/automation/${automationId}/log/?date=${date}`
    );
    const data = await result.json();
    if (result.status >= 400) throw Error(result.statusText);

    return data;
  },
};
